import { FormattedMessage } from '@futrli/localisation';

import { isNil } from 'lodash';
import React from 'react';

import { EXPENSE_CANONICAL_CATEGORIES } from '../../../../core/constants';
import { FormattedAmount } from '../formatted-amount';

import styles from './current-period.scss';

interface Props {
  periodToDateAmount: number;
  predictedAmount: number;
  canonicalCategory?: string;
}

const getValueClass = (difference: number, positiveIsGreen: boolean) => {
  if (difference < 0) {
    return positiveIsGreen ? styles.red : styles.green;
  } else if (difference > 0) {
    return positiveIsGreen ? styles.green : styles.red;
  }
  return '';
};

export const HighlightedDifference: React.FC<Props> = ({ periodToDateAmount, predictedAmount, canonicalCategory }) => {
  const difference = predictedAmount - periodToDateAmount;

  // positive differences to expense accounts should show as red. But default to green.
  const positiveIsGreen = isNil(canonicalCategory) || !EXPENSE_CANONICAL_CATEGORIES.includes(canonicalCategory);

  return (
    <div className={styles.highlightedDifference}>
      <span className={getValueClass(difference, positiveIsGreen)} data-testid="highlighted-difference-amount">
        {difference > 0 && '+'}
        <FormattedAmount amount={difference} maxDigits={0} />
      </span>
      &nbsp;
      <FormattedMessage id="common.predicted" defaultMessage="Predicted" />
    </div>
  );
};
